import { React, useState, useEffect, createContext, useMemo, useRef } from "react";
import request from "../../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment, FormControl, InputLabel, Select } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { capitalizePalabras } from "../../../../Helpers/CapitalizePalabras";
import { FormatMoney } from "../../../../Helpers/FormatNumber";

export const MensajeGarantiaModal = ({ open, onClose, tipoGarantia }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // console.log(tipoGarantia)

    const [mensaje, setMensaje] = useState({
        mensaje: "",
        tipo: tipoGarantia,
        inicio_vigencia: "",
        vigencia: ""
    });

    useEffect(() => {
        if (!open) return;
        setMensaje((prev) => ({
            ...prev,
            tipo: tipoGarantia
        }));
        request
            .get(`DashboardPostventa/MensajeGarantias?tipo=${tipoGarantia}`)
            .then((result) => {
                const msg = result[0];

                const formatDate = (fechaStr) => {
                    if (!fechaStr) return "";
                    const [month, day, year] = fechaStr.split(" ")[0].split("/");
                    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
                };

                setMensaje({
                    mensaje: msg.mensaje || "",
                    tipo: msg.tipo || tipoGarantia,
                    inicio_vigencia: formatDate(msg.inicio_vigencia),
                    vigencia: formatDate(msg.vigencia)
                });
            })
            .catch((error) => {
                console.error("Error cargando mensaje:", error);
            })
    }, [open]);



    const guardarModelo = () => {
        if (mensaje.mensaje === "" || mensaje.mensaje === null || mensaje.mensaje === undefined) {
            Swal.fire({
                title: "GARANTIAS",
                text: "Debe escribir el mensaje de la garantia",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (mensaje.tipo === "" || mensaje.tipo === null || mensaje.tipo === undefined) {
            Swal.fire({
                title: "GARANTIAS",
                text: "Debe seleccionar el tipo de garantia del mensaje",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (mensaje.inicio_vigencia === '' || mensaje.inicio_vigencia === null || mensaje.inicio_vigencia === undefined) {
            Swal.fire({
                title: "GARANTIAS",
                text: "Debe ingresar el inicio del uso de este mensaje ",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (mensaje.vigencia === '' || mensaje.vigencia === null || mensaje.vigencia === undefined) {
            Swal.fire({
                title: "GARANTIAS",
                text: "Debe ingresar una vigencia para el uso del mensaje",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        setLoader({ ...loader, mostrar: true });
        const post = {
            mensaje: mensaje.mensaje,
            tipo: mensaje.tipo,
            inicio_vigencia: mensaje.inicio_vigencia,
            vigencia: mensaje.vigencia
        }
        request
            .post(`DashboardPostventa/AgregarMensajeGarantia`, post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "GARANTIAS",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setMensaje({
                    ...mensaje,
                    mensaje: "",
                    tipo: "",
                    inicio_vigencia: "",
                    vigencia: ""
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("GARANTIAS", JSON.stringify(error), "error");
            });
    };

    const handleDateChange = (e) => {
        setMensaje({ ...mensaje, vigencia: e.target.value });
    };

    const handleDateInicioChange = (e) => {
        setMensaje({ ...mensaje, inicio_vigencia: e.target.value });
    };

    // console.log(mensaje)

    // console.log (JSON.stringify(infoModelo.imagenes.filter(img => img !== null)))
    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="modelos-modal-formulario">
                    <div className="modelos-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"CONFIGURAR MENSAJE DE GARANTIAS"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`modelos-modal-agregar-convenio`}>
                                    <div className="modelos-modal-agregar-convenio-container">
                                        <TextField
                                            select
                                            label="Tipo de garantia"
                                            value={mensaje.tipo}
                                            onChange={(e) => setMensaje({ ...mensaje, tipo: e.target.value })}
                                            size="small"
                                            fullWidth
                                            sx={{ mt: 2 }}
                                        >
                                            <MenuItem value='TMP'>PowerWard Venta Temprana</MenuItem>
                                            <MenuItem value='TRD'>PowerWard Venta Tardía</MenuItem>
                                            <MenuItem value='CKL'>CheckList</MenuItem>
                                        </TextField>
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Mensaje"
                                            size="small"
                                            multiline
                                            rows={6}
                                            value={mensaje.mensaje}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const regex = /^[a-zA-Z0-9ñÑ.,\-#$% ]*$/;

                                                if (regex.test(value)) {
                                                    setMensaje({
                                                        ...mensaje,
                                                        mensaje: value,
                                                    });
                                                }
                                            }}
                                            sx={{
                                                mt: 2,
                                                [`@media (max-height:499px)`]: {
                                                    '& .MuiInputBase-root': {
                                                        height: '28px',
                                                    },
                                                    '& input': {
                                                        padding: '4px 6px',
                                                    },
                                                },
                                            }}
                                            fullWidth
                                        />
                                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                            <TextField
                                                id="vigencia"
                                                label="Inicio de vigencia"
                                                type="date"
                                                size="small"
                                                fullWidth
                                                value={mensaje.inicio_vigencia}
                                                onChange={handleDateInicioChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />
                                            <TextField
                                                id="vigencia"
                                                label="Vigencia"
                                                type="date"
                                                size="small"
                                                fullWidth
                                                value={mensaje.vigencia}
                                                onChange={handleDateChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />

                                        </Box>
                                    </div>
                                    <div className="modelos-modal-buttons">
                                        <button
                                            className="modelos-modal-button-guardar"
                                            onClick={() => guardarModelo()}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};